<script>
import { mapGetters } from 'vuex';
import PageHeader from '../../SettingsSubPageHeader.vue';
import Twilio from './Twilio.vue';
import ThreeSixtyDialogWhatsapp from './360DialogWhatsapp.vue';
import CloudWhatsapp from './CloudWhatsapp.vue';
import EmbeddedWhatsapp from './EmbeddedWhatsapp.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    ThreeSixtyDialogWhatsapp,
    CloudWhatsapp,
    EmbeddedWhatsapp,
  },
  data() {
    return {
      provider: 'embedded',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    isSuperAdmin() {
      return this.currentUser?.type === 'SuperAdmin';
    },
    providerOptions() {
      const options = [
        {
          value: 'embedded',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.EMBEDDED'),
        },
        {
          value: 'twilio',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO'),
        },
      ];

      if (this.isSuperAdmin)
        options.push({
          value: 'whatsapp_cloud',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD'),
          superOnly: true,
        });

      return options;
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
        <select v-model="provider" class="mt-1">
          <option
            v-for="options in providerOptions"
            :key="options.value"
            :value="options.value"
          >
            {{ options.label }}
          </option>
        </select>
      </label>
    </div>

    <Twilio v-if="provider === 'twilio'" type="whatsapp" />
    <ThreeSixtyDialogWhatsapp v-else-if="provider === '360dialog'" />
    <EmbeddedWhatsapp v-if="provider === 'embedded'" />
    <CloudWhatsapp v-else-if="provider === 'whatsapp_cloud' && isSuperAdmin" />
  </div>
</template>
